import { NoiseCancellationType, VirtualBackgroundType } from '../../../../../common/types/settings';

export interface SetDeviceActionPayload {
    deviceId: string;
}

export type SetDeviceActionMeta =
    | {
          isSyncFromHost?: boolean;
          isInit?: boolean;
      }
    | undefined;

export type StoreDevice = Omit<MediaDeviceInfo, 'toJSON'>;
export enum FacingMode {
    USER = 'user',
    ENVIRONMENT = 'environment',
}
export interface SecuritySettings {
    onlyBetaTesters: boolean;
    showPromptBeforeConnection: boolean;
}

export interface MediaSettings {
    isInputDeviceChangeAvailable: boolean;
    isOutputDeviceChangeAvailable: boolean;

    devices: StoreDevice[];

    audioOutputDeviceId: string;
    audioInputDeviceId: string;
    videoInputDeviceId: string;

    showMyVideo: boolean;
    joinWithCameraOff: boolean;
    joinWithMicrophoneOff: boolean;

    videoFacingMode: FacingMode;

    noiseCancellationType: NoiseCancellationType;
    virtualBackgroundType: VirtualBackgroundType;

    hideParticipantsVideo: boolean;
    bandwidthEffective4kCodec: boolean;
}

export interface SettingsState {
    security: SecuritySettings;
    media: MediaSettings;
    checkDesktopAppExistence: boolean;
    isShownLimitMessage: boolean;
    isFaqModalVisible: boolean;
    isFeedbackFormVisible: boolean;
    isSettingsReady: boolean;
    isAudioInputDiagnosticRun: boolean;
    isAudioOutputDiagnosticRun: boolean;
    wasParticipantsVideoNotificationShown: boolean;
    summarizationWelcomePopupWasShown: boolean;
    summarizationStartPopupWasShown: boolean;
}

export interface SupportFeedbackForm {
    email: string;
    description: string;
}
